import { t } from "i18next";
import * as Yup from "yup";

export const INITIAL_FORM_VALUES = { email: "", password: "" };

export const DEFAULT_EMAIL = "oliver@example.com";
export const DEFAULT_PASSWORD = "welcome";

export const LOGIN_FORM_VALIDATION_SCHEMA = Yup.object().shape({
  email: Yup.string()
    .email(t("neetoMolecules.login.invalidEmail"))
    .required(t("neetoMolecules.login.emailRequired")),
  password: Yup.string().required(t("neetoMolecules.login.passwordRequired")),
});
